export function getUsers({
  searchText,
  isActive,
  userTypeCode,
  pageNumber,
  pageSize,
}) {
  return window.axios
    .get(`/hub/v1/users`, {
      params: { searchText, isActive, userTypeCode, pageNumber, pageSize },
    })
    .then((response) => response.data);
}

export function getUserSearchParams() {
  return window.axios
    .get(`/hub/v1/users/items`)
    .then((response) => response.data);
}

export function getUserById(id) {
  return window.axios
    .get(`/hub/v1/users/${id}`)
    .then((response) => response.data);
}

export function addUser({
  username,
  organizationName,
  userTypeCode,
  password,
}) {
  return window.axios
    .post(`/hub/v1/users`, {
      username,
      organizationName,
      userTypeCode,
      password,
    })
    .then((response) => response.data);
}

export function updateUser({ id, organizationName, userTypeCode, password }) {
  return window.axios
    .put(`/hub/v1/users/${id}`, {
      organizationName,
      userTypeCode,
      password,
    })
    .then((response) => response.data);
}

export function changeUserStatus({ id, isActive }) {
  return window.axios
    .put(`/hub/v1/users/${id}/change-status`, { isActive })
    .then((response) => response.data);
}

export function checkUsernameAvailability(username) {
  return window.axios
    .get(`/hub/v1/users/check-username/`, { params: { username } })
    .then((response) => response.data);
}

export function getUserApis(id) {
  return window.axios
    .get(`/hub/v1/users/${id}/apis`)
    .then((response) => response.data);
}

export function changeUserApiStatus({ userId, apiId, isActive }) {
  return window.axios
    .put(`/hub/v1/users/${userId}/apis/${apiId}/change-status`, { isActive })
    .then((response) => response.data);
}

export function getUserApisLogs({ userId, apiId }) {
  return window.axios
    .get(`/hub/v1/users/${userId}/apis/${apiId}/change-histories`)
    .then((response) => response.data);
}
